// extracted by mini-css-extract-plugin
module.exports = {"importOverview":"component_importOverview__wVtJN","table":"component_table__1QlPy"};